export default __webpack_public_path__ + "static/media/default.1c7057217605f8a74692e7faf96a9e6e.png";